module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-收起内容.c900d.png";